import { render, staticRenderFns } from "./TeamPartner.vue?vue&type=template&id=4530b725&scoped=true"
import script from "./TeamPartner.vue?vue&type=script&lang=js"
export * from "./TeamPartner.vue?vue&type=script&lang=js"
import style0 from "./TeamPartner.vue?vue&type=style&index=0&id=4530b725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530b725",
  null
  
)

export default component.exports